import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  startTime: null,
  totalDistance: 0,
  path: [],
  riding : false,
};

export const rideSlice = createSlice({
  name: "ride",
  initialState,
  reducers: {
    setStartTime: (state, { payload }) => {
      state.startTime = payload;
    },
    addPathPoint: (state, { payload }) => {
      state.path.push(payload);
    },
    resetPath: (state) => {
      state.path = [];
    },
    setTotalDistance: (state, { payload }) => {
      // state.totalDistance = payload;
      state.totalDistance += payload;
    },
    resetRideState: (state) => {
      state.startTime = null;
      state.totalDistance = 0;
      state.path = [];
    },
    setRidingState: (state, { payload }) => {
      state.riding = payload;
    },
  },
});

export const {
  setStartTime,
  addPathPoint,
  resetPath,
  setTotalDistance,
  resetRideState,
  setRidingState,
} = rideSlice.actions;

export default rideSlice.reducer;
